import React from 'react';
import './play-controls.scss';

export type PlayControlsProps = {
    paused: boolean,
    togglePaused: () => void,
    rewind?: () => void,
    fastForward?: () => void,
    toStart?: () => void,
    toEnd?: () => void,
    showSkipControls?: boolean
}

export function PlayControls({
    paused,
    togglePaused,
    rewind,
    fastForward,
    toStart,
    toEnd,
    showSkipControls = true
}: PlayControlsProps) {
    return (
        <div className="play-controls">
            {showSkipControls ?
                <>
                    <button className="play-controls__btn play-controls__btn--sm" onClick={toStart}>
                        <img src="assets/button-start.svg" alt="Start" />
                    </button>
                    <button className="play-controls__btn" onClick={rewind}>
                        <img src="assets/button-rewind.svg" alt="Rewind" />
                    </button>
                </>
                : null}
            <button className="play-controls__btn play-controls__btn--lg" onClick={togglePaused}>
                {paused ?
                    <img src="assets/button-play.svg" alt="Play" /> :
                    <img src="assets/button-pause.svg" alt="Pause" />
                }
            </button>
            {showSkipControls ?
                <>
                    <button className="play-controls__btn" onClick={fastForward}>
                        <img src="assets/button-forward.svg" alt="Fast forward" />
                    </button>
                    <button className="play-controls__btn play-controls__btn--sm" onClick={toEnd}>
                        <img src="assets/button-end.svg" alt="End" />
                    </button>
                </>
                : null}
        </div>
    )
}
